import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import BottomNav from './components/BottomNav';
import OfflineIndicator from './components/OfflineIndicator';
import InstallBanner from './components/InstallBanner';
import Home from './pages/Home';
import Landing from './pages/Landing';
import LogMeal from './pages/LogMeal';
import History from './pages/History';
import Insights from './pages/Insights';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyRedirect from './pages/VerifyRedirect';
import Onboarding from './pages/Onboarding';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import ProtectedRoute from './components/ProtectedRoute';
import { initDB } from './services/offlineStorage';
import { setupOnlineListener } from './services/syncService';
import { Analytics } from '@vercel/analytics/react';

function HomeOrLanding() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!user) {
    return <Landing />;
  }

  return (
    <>
      <Home />
      <BottomNav />
    </>
  );
}

function App() {
  useEffect(() => {
    // Initialize offline database and listeners
    initDB().catch(console.error);
    setupOnlineListener();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <OfflineIndicator />
        <InstallBanner />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth/verify" element={<VerifyRedirect />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/landing" element={<Landing />} />
          <Route
            path="/"
            element={<HomeOrLanding />}
          />
          <Route
            path="/log-meal"
            element={
              <ProtectedRoute>
                <LogMeal />
                <BottomNav />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <History />
                <BottomNav />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights"
            element={
              <ProtectedRoute>
                <Insights />
                <BottomNav />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
                <BottomNav />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Analytics />
    </AuthProvider>
  );
}

export default App;
